import { useEffect, useState } from 'react';
import { runtimeApi, type DependencyGraph } from '../../api/moduleruntime';

export function DependencyGraphPage() {
  const [graph, setGraph] = useState<DependencyGraph | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void runtimeApi.dependencies('orders').then(setGraph).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Dependency Graph</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Module dependency tree with version compatibility.</p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <h2 className="font-medium">Nodes</h2>
          <ul className="mt-3 space-y-2 text-sm">
            {graph?.nodes.map((n) => (
              <li key={n.module_id} className="rounded border px-3 py-2 dark:border-slate-700">
                <span className="font-medium">{n.name}</span>
                <span className="ml-2 text-xs text-slate-500">v{n.version} · {n.state}</span>
                {n.dependencies.length > 0 && (
                  <p className="mt-1 text-xs text-slate-500">Depends on: {n.dependencies.join(', ')}</p>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <h2 className="font-medium">Edges</h2>
          <ul className="mt-3 space-y-1 text-sm font-mono">
            {graph?.edges.map((e, i) => (
              <li key={i}>{e.from} → {e.to}{e.optional ? ' (optional)' : ''}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
